// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_find_us_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Pay us a visit to try how it feels to walk on air!`
};

const el_find_us_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Επισκεφθείτε μας για να νιώσετε πώς είναι να περπατάς στον αέρα!`
};

const ru_find_us_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Посетите нас, чтобы ощутить, каково это — ходить по воздуху!`
};

const he_find_us_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `בקרו אותנו וחוו איך זה להרגיש כמו הליכה על אוויר!`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const find_us_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.find_us_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("find_us_subtitle", locale)
	if (locale === "en") return en_find_us_subtitle(inputs)
	if (locale === "el") return el_find_us_subtitle(inputs)
	if (locale === "ru") return ru_find_us_subtitle(inputs)
	if (locale === "he") return he_find_us_subtitle(inputs)
	return "find_us_subtitle"
};